import { render, staticRenderFns } from "./FormProductTagManage.vue?vue&type=template&id=2526fa90"
import script from "./FormProductTagManage.vue?vue&type=script&lang=js"
export * from "./FormProductTagManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports